import React from "react";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const ScribbleTooltip = () => {

  const questionView = useSelector( state => state.questionView );

  const { t } = useTranslation();

  return (
    <div className={ clsx( 'note_guide', 2 === questionView.scribbleTooltipStatus && 'disappear' ) } style={ { pointerEvents : 'none' } }>
      <div className="txt_box" dangerouslySetInnerHTML={ { __html : t( 'LC_05_20.msg018' ) } } />
    </div>
  );

};

export default ScribbleTooltip;
